
    import '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-react-agent-use-tbox-demo-tbox"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?type=demo')
};